import axios from "axios";

const state = {
    terms: '',
    has_accepted_terms: undefined,
    loading: false,
    saving: false,
}

const mutations = {
    setTerms(state, terms) {
        state.terms = terms;
    },
    setHasAcceptedTerms(state, has_accepted_terms){
        state.has_accepted_terms = has_accepted_terms;
    },
    setLoading(state, is_loading){
        state.loading = is_loading;
    },
    setSaving(state, is_saving){
        state.saving = is_saving;
    }
}

const actions = {
    updateHasAcceptedTerms(context, has_accepted_terms){
       context.commit('setHasAcceptedTerms', has_accepted_terms);
    },

    acceptTerms(context, params) {
        return new Promise((resolve, reject) => {
            context.commit('setSaving', true);
            axios.post('auth/terms/accept-terms', {
                terms_id : params.terms_id
            }).then(response => {
                console.log('data', response.data);
                if (response.data.status === 'success' && response.data.has_accepted_terms) {
                    context.commit('setHasAcceptedTerms', true);
                }else{
                    context.commit('setHasAcceptedTerms', false);
                }
                resolve(response);
            }).catch(error => {
                reject(error);
            }).finally(() => {
                context.commit('setSaving', false);
            });
        });
    },
    loadTerms(context, payload) {
        context.commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios.get('/auth/terms/list-terms/' + payload.lang).then(response => {
                if (response.data.status === 'success') {
                    context.commit('setTerms', response.data.terms);
                }
                resolve(response);
            }).catch(error => {
                reject(error);
            }).finally(() => {
                context.commit('setLoading', false);
            });
        });
    },
}

const getters = {
    getTerms(state){
        return state.terms;
    },
    getHasAcceptedTerms(state){
        return state.has_accepted_terms;
    },
    getIsLoading(state){
        return state.loading;
    },
    getIsSaving(state){
        return state.saving;
    }
}

export default {namespaced: true, state, mutations, actions, getters}
